import type { Leaves } from '@talos/kyoko';
import type { CARE_ORDER_EXPORT_MAKER_COLUMN_PREFIX } from './columns/careOrderExportMakerColumns';
import type { CareOrderBlotterEntity } from './types';

/**
 * A collection of all the established custom column ids used to allow us to get some typechecking value and safety
 * Its not perfect, but its a pragmatic approach which gives us a lot of bang for our buck
 */
export const CARE_ORDER_CUSTOM_COLUMN_IDS = {
  Type: 'Type',
  Side: 'Side',
  CumQty: 'CumQty',
  CumAmt: 'CumAmt',
  UnitsTraded: 'units-traded',
  FixingIndices: 'fixingIndices',
  Route: 'route',
  SubAccount: 'SubAccount',
  FilledNotional: 'filledNotional',
  OpenNotional: 'openNotional',
  TotalNotional: 'totalNotional',
  FilledCounterAmount: 'filledCounterAmount',
  ProductType: 'productType',
  BaseQty: 'baseQty',
  FixingPrice: 'fixingPrice',
  FixingDate: 'fixingDate',
  Action: 'action',
} as const;

type CareOrderCustomColumnID = (typeof CARE_ORDER_CUSTOM_COLUMN_IDS)[keyof typeof CARE_ORDER_CUSTOM_COLUMN_IDS];
type CareOrderExportMakerColumnID = `${typeof CARE_ORDER_EXPORT_MAKER_COLUMN_PREFIX}:${string}:${'bid' | 'offer'}`;

/** All valid AG Grid colIds for the Care Order blotter. */
export type CareOrderBlotterColumnID =
  | Leaves<CareOrderBlotterEntity>
  | CareOrderCustomColumnID
  | CareOrderExportMakerColumnID;
